//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OrderList',
  $dictKeyList: [
    {
      key: '3',
      name: '订单状态',
    },
    {
      key: '5',
      name: '订单类型',
    },
  ],
  data() {
    return {
      filterForm: {
        orderCategory: 2, //2: 托管订单，3：流转订单
        client: '',
        trustee: '',
        orderType: '',
        cropId: '',
        workType: '',
        statusFlag: '',
        clientAccountId: '',
      },
      cropData: [],
      workTypeData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      orders: [],
    }
  },
  filters: {
    formatDate(value) {
      let result = ''
      let ary = value.split('-')
      result = `${ary[0]}年${ary[1]}月${ary[2]}日`
      return result
    },
  },
  watch: {
    'filterForm.cropId'(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = ''
        this.workTypeData = []
        this.getCropWork2({ cropId2: newValue })
      }
    },
  },
  mounted() {
    this.filterForm.clientAccountId = this.$route.query.$businessAccountId
    this.getOrderList()
    this.getAllCropList()
    this.getCropWork2()
  },
  methods: {
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data
      })
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:35:18
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.orderType == 0) {
        delete this.allFilters.orderType
      }
      if (this.allFilters.cropId == 0) {
        delete this.allFilters.cropId
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getOrderList() {
      this.getAllFilters()
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.order.getOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data
        this.pagination.recordTotal = recordTotal
        this.orders = orders
      })
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getOrderList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/village/trustee/order/detail',
        query: { id: params.id },
      })
    },
  },
}
